export default class AbstractStorageStrategy {
    async getItems() {
        const keys = await this.keys();
        const result = {};
        const promises = keys.map(async (key) => {
            const value = (await this.getItem(key)) ?? null;
            if (value === null) {
                return;
            }
            result[key] = value;
        });
        await Promise.all(promises);
        return result;
    }
    async setItems(items) {
        const promises = Object.entries(items).map(([key, value]) => this.setItem(key, value));
        await Promise.all(promises);
    }
    async length() {
        const keys = await this.keys();
        return keys.length;
    }
}
